<template>
  <div class="row">
    <slot />
  </div>
</template>
<script>
export default {
  name: 'VRow',
};
</script>

<style lang="scss">
$gap: 10px;

.row {
  display: flex;
  flex-wrap: wrap;
  margin-left: -15px;
  margin-right: -15px;

  .col {
    padding-left: 15px;
    padding-right: 15px;

    &--no-padding {
      padding-left: 0;
      padding-right: 0;
    }
  }
}
</style>
